export default __webpack_public_path__ + "styles/icons/3LCarboy.svg";